export default {
  data() {
    return {
      resourceLoader: false,
      monthYear: "",
      monthly: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "managed_by",
          label: "Managed By",
        },
        {
          key: "reporting_to",
          label: "Reporting To",
        },
        {
          key: "billable_allocation",
          label: "Total Billable Allocation",
        },
        {
          key: "non_billable_allocation",
          label: "Total Non Billable Allocation",
        },
        {
          key: "total_hours",
          label: "Total Hours",
        },
      ],
      monthlyItems: [],
      currentPage: 1,
      perPage: 10,
      totalCount: 0,
    };
  },

  mounted() {
    this.monthYear = this.$route.query.date;
    this.monthlyPlanList();
  },

  watch: {
    currentPage() {
      this.monthlyPlanList();
    },
  },

  methods: {
    back() {
      this.$router.back();
    },

    handlePageChange(page) {
      this.currentPage = page;
    },

    /*  resource plans */
    async monthlyPlanList() {
      this.resourceLoader = true;
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        report_id: this.$route.params.id,
      };
      const response = await this.getHTTPPostResponse(
        "/querterly-resource-report/quarterly-details",
        input,
        false
      );

      if (response && response.data) {
        const data = response.data.users;
        this.totalCount = response.data.count;
        this.monthlyItems = data.reduce((acc, item) => {
          if (!acc[item.id]) {
            acc[item.id] = [];
          }
          acc[item.id].push(item);
          return acc;
        }, {});

        /*  to get total hours & percentage */
        Object.keys(this.monthlyItems).forEach((element) => {
          let total = 0;
          let actualTotal = 0;

          if (
            this.monthlyItems[element][0].resource_plan &&
            this.monthlyItems[element][0].resource_plan.length
          ) {
            this.monthlyItems[element][0].resource_plan.forEach((element) => {
              total += element.planned_hours ? element.planned_hours : 0;
              actualTotal += element.allocation_hours
                ? Number(element.allocation_hours)
                : 0;
            });
          }
          this.monthlyItems[element][0].totalHours = total;
          this.monthlyItems[element][0].actualTotal = actualTotal;
          this.monthlyItems[element][0].percentage =
            total == 0
              ? 0
              : parseFloat(((total * 100) / 160).toFixed(2)).toString();
        });
        this.resourceLoader = false;
      } else {
        this.resourceLoader = false;
      }
    },
  },
};
